// The applied quick filter, shown as a chip: its expression (cut to 30
// characters), X to clear it, and a click to open the filter again when
// onClick is given. Tables' controls (TableControls) and the respondent data
// view (VariablesData, #1887) show the same chip.
import React from 'react'
import { Chip } from '@mui/material'

export const QUICK_FILTER_CHIP_MAX = 30

interface QuickFilterChipProps {
  filter: string
  onClear?: () => void
  onClick?: () => void
}

export const QuickFilterChip: React.FC<QuickFilterChipProps> = ({ filter, onClear, onClick }) => (
  <Chip
    aria-label={`Quick filter: ${filter}`}
    label={filter.length > QUICK_FILTER_CHIP_MAX ? filter.slice(0, QUICK_FILTER_CHIP_MAX) + '...' : filter}
    size="small"
    onClick={onClick}
    onDelete={onClear}
    sx={{ maxWidth: 200, fontSize: '0.7rem', mr: 0.5 }}
  />
)

export default QuickFilterChip
